export default class UpdateCustomerModel {
  name?: string;

  contacts?: string;

  phonePrefix?: string;

  phoneNo?: string;

  address?: string;

  remark?: string;

  accessGroup?: string
}
